

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface CouncilParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Council {
    id?: number;
    name: string;
    
  parameters?: CouncilParameter[];
  links?: any;
}

export abstract class CouncilData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Council[]>;
  abstract create(url: string,data: Council): Observable<any>;
  abstract update(url: string,data: Council): Observable<any>;
  abstract delete(url: string): Observable<any>;
}